module.exports = __webpack_public_path__ + "static/media/globe.57f25d5c.png";